import React, { useEffect, useState } from "react";
import classes from "./RegisterZipGame.module.css";
import Header from "../../components/Header";
import ZipGameStepper from "../../components/ZipGameStepper";
import { useLocation, useNavigate } from "react-router-dom";
import { registerZipUser } from "../../http/http";
import { useDispatch } from "react-redux";
import { setUserZip } from "../../store/slices/userZipGameTokenSlice";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ZipGameUserDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const msisdn = location?.state?.msisdn || "";
  const [fullName, setFullName] = useState("");

  const dispatch = useDispatch();

  const {t}=useTranslation();

  useEffect(() => {
    if (!msisdn) {
      navigate("/register/zip-game");
    }
  }, [msisdn, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!fullName || fullName.trim().length == 0) {
        return;
      }

      const response = await registerZipUser(msisdn, fullName);
      console.log(response?.data?.result, 'response==');

      if (response?.data?.result?.regiserStatus == 1) {
        // user is already registered
        dispatch(setUserZip(response?.data?.result));
        navigate("/zip-game-details");
      }
      else if (response?.data?.result?.regiserStatus == 2) {
        // new user registered successfully!
        dispatch(setUserZip(response?.data?.result));
        navigate("/zip-game-details");
      }
      else {
        // something went wrong! please try again!
        toast.error(t("86"));
      }

    } catch (error) {
      console.log(error, 'error--');
    }
  };

  return (
    <>
      <Header />

      <div className={classes.container}>
        <div className={classes.heroCard}>
          <div className={classes.heroBadge}>ZIP GAME</div>
          <h1 className={classes.heroTitle}>{t("295")}</h1>
          <p className={classes.heroText}>
            {t("296")}
          </p>
        </div>

        <ZipGameStepper currentStep={3} />

        <div className={classes.formCard}>
          <form className={classes.section} onSubmit={handleSubmit}>
            <div className={classes.sectionHead}>
              <h2 className={classes.sectionTitle}>{t("297")}</h2>
              <p className={classes.sectionText}>
                {t("298")}
              </p>
            </div>

            <div className={classes.inputGroup}>
              <label className={classes.label} htmlFor="fullName">
                {t("299")}
              </label>
              <input
                id="fullName"
                type="text"
                className={classes.input}
                placeholder={t("300")}
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
              />
            </div>

            <div className={classes.actionRow}>

              <button type="submit" className={classes.primaryBtn}>
                {t("301")}
              </button>
              <button
                type="button"
                className={classes.secondaryBtn}
                onClick={() =>
                  navigate("/register/zip-game")
                }
              >
                {t("302")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ZipGameUserDetails;